import { Link } from 'react-router-dom';
import { Phone, ArrowRight, Tag, FileDown } from 'lucide-react';
import { useToast } from '@/components/ui/use-toast';
import { downloadFile } from '@/lib/download';
import { WhatsAppIcon, WHATSAPP_HREF } from '@/components/WhatsAppButton';

const SAMPLE_REPORT_URL = 'https://storage.googleapis.com/daley-inventories-assets/sample-report.pdf';

export default function CampaignActionBar() {
  const { toast } = useToast();

  const handleDownload = async () => {
    try {
      await downloadFile(SAMPLE_REPORT_URL, 'DaleyInventories-SampleReport-2026.pdf');
    } catch {
      toast({ title: 'Download Error', description: 'Could not download the sample report. Please try again.', variant: 'destructive' });
    }
  };

  return (
    <section className="bg-navy-dark text-white border-t border-white/10">
      <div className="max-w-[1600px] mx-auto px-4 sm:px-6 md:px-10 lg:px-16">
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-px bg-white/10">
          <Link to="/pricing" className="flex items-center justify-center gap-2 py-4 sm:py-5 bg-navy-dark hover:bg-white/5 transition-colors">
            <Tag size={18} className="text-orange" />
            <span className="font-semibold text-sm sm:text-base">View Prices</span>
          </Link>
          <a href="tel:02089355492" className="flex items-center justify-center gap-2 py-4 sm:py-5 bg-navy-dark hover:bg-white/5 transition-colors">
            <Phone size={18} className="text-orange" />
            <span className="font-semibold text-sm sm:text-base">Call Us</span>
          </a>
          <a href={WHATSAPP_HREF} target="_blank" rel="noopener noreferrer" className="flex items-center justify-center gap-2 py-4 sm:py-5 bg-navy-dark hover:bg-white/5 transition-colors">
            <WhatsAppIcon className="w-[18px] h-[18px] text-[#25D366]" />
            <span className="font-semibold text-sm sm:text-base">WhatsApp</span>
          </a>
          <Link to="/book-now" className="flex items-center justify-center gap-2 py-4 sm:py-5 bg-navy-dark hover:bg-white/5 transition-colors">
            <ArrowRight size={18} className="text-orange" />
            <span className="font-semibold text-sm sm:text-base">Book Online</span>
          </Link>
          <button onClick={handleDownload} className="col-span-2 sm:col-span-1 lg:col-span-1 flex items-center justify-center gap-2 py-4 sm:py-5 bg-navy-dark hover:bg-white/5 transition-colors w-full">
            <FileDown size={18} className="text-orange" />
            <span className="font-semibold text-sm sm:text-base">Sample Report</span>
          </button>
        </div>
      </div>
    </section>
  );
}